import type {
  RyftDirectorUpdateRequestType,
  RyftDirectorUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementDirectorUpdate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: ({
      directorId,
      data,
    }: {
      directorId: string;
      data: RyftDirectorUpdateRequestType;
    }) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `ryft-management/accounts/directors/${directorId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<RyftDirectorUpdateResponseType>(response).data,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RyftManagementAccount,
        ],
      });
    },
  });
};
